export default "__VITE_ASSET__DZkMjbCU__"